import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  exportExcel,
  batchUploadJt808ParameterData,
  uploadJt808ParameterDataFile,
  batchUploadJt808ParameterDataFile
} from '@/api/jt808parameterdataserv'

export default {
  state: {
    state_Jt808ParameterData_AddObjResult: null,
    state_Jt808ParameterData_GetAllResult: null,
    state_Jt808ParameterData_GetPageResult: null,
    state_Jt808ParameterData_GetDetailResult: null,
    state_Jt808ParameterData_ModifyObjResult: null,
    state_Jt808ParameterData_DeleteObjResult: null,
    state_Jt808ParameterData_ExportExcelResult: null,
    state_Jt808ParameterData_BatchUploadJt808ParameterDataResult: null,
    state_Jt808ParameterData_UploadJt808ParameterDataFileResult: null,
    state_Jt808ParameterData_BatchUploadJt808ParameterDataFileResult: null
  },
  mutations: {
    SET_JT808PARAMETERDATA_ADDOBJ_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_AddObjResult = rst
    },
    SET_JT808PARAMETERDATA_GETALL_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_GetAllResult = rst
    },
    SET_JT808PARAMETERDATA_GETPAGE_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_GetPageResult = rst
    },
    SET_JT808PARAMETERDATA_GETDETAIL_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_GetDetailResult = rst
    },
    SET_JT808PARAMETERDATA_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_ModifyObjResult = rst
    },
    SET_JT808PARAMETERDATA_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_DeleteObjResult = rst
    },
    SET_JT808PARAMETERDATA_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_ExportExcelResult = rst
    },
    SET_JT808PARAMETERDATA_BATCHUPLOADJT808PARAMETERDATA_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_BatchUploadJt808ParameterDataResult = rst
    },
    SET_JT808PARAMETERDATA_UPLOADJT808PARAMETERDATAFILE_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_UploadJt808ParameterDataFileResult = rst
    },
    SET_JT808PARAMETERDATA_BATCHUPLOADJT808PARAMETERDATAFILE_RESULT: (state, rst) => {
      state.state_Jt808ParameterData_BatchUploadJt808ParameterDataFileResult = rst
    }
  },
  actions: {
    Jt808ParameterDataServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_ExportExcel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_EXPORTEXCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_EXPORTEXCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_BatchUploadJt808ParameterData ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchUploadJt808ParameterData(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_BATCHUPLOADJT808PARAMETERDATA_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_BATCHUPLOADJT808PARAMETERDATA_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_UploadJt808ParameterDataFile ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        uploadJt808ParameterDataFile(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_UPLOADJT808PARAMETERDATAFILE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_UPLOADJT808PARAMETERDATAFILE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterDataServ_BatchUploadJt808ParameterDataFile ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchUploadJt808ParameterDataFile(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETERDATA_BATCHUPLOADJT808PARAMETERDATAFILE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETERDATA_BATCHUPLOADJT808PARAMETERDATAFILE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Jt808ParameterData_AddObjResult: state => {
      return state.state_Jt808ParameterData_AddObjResult
    },
    get_Jt808ParameterData_GetAllResult: state => {
      return state.state_Jt808ParameterData_GetAllResult
    },
    get_Jt808ParameterData_GetPageResult: state => {
      return state.state_Jt808ParameterData_GetPageResult
    },
    get_Jt808ParameterData_GetDetailResult: state => {
      return state.state_Jt808ParameterData_GetDetailResult
    },
    get_Jt808ParameterData_ModifyObjResult: state => {
      return state.state_Jt808ParameterData_ModifyObjResult
    },
    get_Jt808ParameterData_DeleteObjResult: state => {
      return state.state_Jt808ParameterData_DeleteObjResult
    },
    get_Jt808ParameterData_ExportExcelResult: state => {
      return state.state_Jt808ParameterData_ExportExcelResult
    },
    get_Jt808ParameterData_BatchUploadJt808ParameterDataResult: state => {
      return state.state_Jt808ParameterData_BatchUploadJt808ParameterDataResult
    },
    get_Jt808ParameterData_UploadJt808ParameterDataFileResult: state => {
      return state.state_Jt808ParameterData_UploadJt808ParameterDataFileResult
    },
    get_Jt808ParameterData_BatchUploadJt808ParameterDataFileResult: state => {
      return state.state_Jt808ParameterData_BatchUploadJt808ParameterDataFileResult
    }
  }
}
